import { Component, Inject, OnInit } from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { DeviceInfoService } from '../../services/device-info.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';

@Component({
  selector: 'gtapp-screenshot-guide',
  templateUrl: './screenshot-guide.component.html',
  styleUrl: './screenshot-guide.component.scss',
  standalone: false,
})
export class ScreenshotGuideComponent implements OnInit {
  guideSteps: any = [];
  currentStep = 0;

  currentDeviceInfo: any = {};

  screenShotGuide: string = 'iosPWAInstallation';
  safariPermissionSettingsUpdated: boolean = false;

  safariPermissionsGuide = [
    {
      imgSrc: 'assets/screenshots/ios_safari_prompts/ios_safari_options.avif',
      description:
        '<div class="p-2 mb-2">For the best experience, we recommend following these quick steps.</div>',
    },
    {
      imgSrc:
        'assets/screenshots/ios_safari_prompts/ios_safari_three_dots.avif',
      description: '<div class="p-2 mb-2">Tap the three dots.</div>',
    },
    {
      imgSrc:
        'assets/screenshots/ios_safari_prompts/ios_allow_permission_v2.avif',
      description:
        '<div class="p-2 mb-2">Scroll down and set <span class="fw-semibold text-primary">Camera</span>, <span class="fw-semibold text-primary">Microphone</span>, and <span class="fw-semibold text-primary">Location</span> all to <span class="fw-semibold">Allow</span>.</div>',
    },
  ];

  safariPWAGuide = [
    {
      imgSrc: 'assets/screenshots/iPhone_1_v3.avif',
      description: '<div class="p-2 mb-2">Tap the three dots.</div>',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_2_v3.avif',
      description:
        '<div class="p-2 mb-2">Tap <span class="fw-semibold">Share</span></div>',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_3_v3.avif',
      description: '<div class="p-2 mb-2">Tap the three dots (More).</div>',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_4_v3.avif',
      description:
        '<div class="p-2 mb-2">Tap <span class="fw-semibold">Add to Home Screen</span></div>',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_5_v3.avif',
      description:
        '<div class="p-2 mb-2">Tap <span class="fw-semibold"6>Add</span></div>',
    },
  ];

  chromeGuide = [
    {
      imgSrc: 'assets/screenshots/iPhone_1_Chrome.avif',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_3_v3.avif',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_4_v3.avif',
    },
    {
      imgSrc: 'assets/screenshots/iPhone_5_v3.avif',
    },
  ];

  constructor(
    private deviceInfoService: DeviceInfoService,
    protected ref: DialogRef,
    @Inject(DIALOG_DATA) public dialogData: any,
  ) {}

  async ngOnInit(): Promise<void> {
    this.safariPermissionSettingsUpdated =
      localStorage.getItem(btoa('safariPermissionSettingsUpdated')) === 'true';
    this.screenShotGuide = this.dialogData?.guide || this.screenShotGuide;
    this.currentDeviceInfo = await this.deviceInfoService.getDeviceInfo();

    if (this.screenShotGuide === 'iosPWAInstallation') {
      if (
        this.currentDeviceInfo.device !== 'iPhone' ||
        !['Chrome', 'Safari']?.includes(this.currentDeviceInfo?.browser)
      ) {
        this.close();
        return;
      }
      if (this.currentDeviceInfo.browser == 'Chrome') {
        this.guideSteps = this.chromeGuide;
      } else {
        if (this.safariPermissionSettingsUpdated) {
          this.guideSteps = this.safariPWAGuide;
        } else {
          this.guideSteps = [
            ...this.safariPermissionsGuide,
            ...this.safariPWAGuide,
          ];
        }
      }
    } else {
      this.guideSteps = this.safariPermissionsGuide;
    }
  }
  navigate(step: number) {
    this.currentStep += step;
  }

  close() {
    if (this.screenShotGuide === 'safariPermissionPrompts')
      localStorage.setItem(
        btoa('safariPermissionSettingsUpdated'),
        String(this.safariPermissionSettingsUpdated),
      );
    this.ref.close('close');
  }
  updateSafariPermissionStatus(event: any) {
    this.safariPermissionSettingsUpdated = event.target.checked;
  }
}
